import type { QueryClient } from "@tanstack/react-query"

import type { AuthUser } from "./auth-api"

export type RouterAuthState = {
  user: AuthUser | null
  status: "pending" | "guest" | "authenticated"
}

export type AppRouterContext = {
  queryClient: QueryClient
  auth: RouterAuthState
}

export const pendingRouterAuthState: RouterAuthState = {
  user: null,
  status: "pending",
}
